<div class="dialog-container">
  <div class="dialog-title">
    <div class="dialog-close" (click)="dialogRef.close()"><i class="mdi mdi-close"></i></div>
    {{"PICTURES.TITLE"| translate}}
  </div>
  <div class="dialog-body">
    <div class="upload-btn-box" *ngIf="imageChangedEvent == ''">
      <input type="file" class="image-input" id="imageSelector" [hidden]="true" (change)="fileChanged($event)">
      <label class="w-link-btn" for="imageSelector">
        <i class="mdi mdi-plus"></i>
        {{"PICTURES.UPLOAD"| translate}}
      </label>
    </div>
    <div *ngIf="imageChangedEvent != ''">
      <div class="original-image">
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1"
          [resizeToWidth]="160"
          format="png"
          (imageCropped)="imageCropped($event)"
          (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
      </div>
      <div class="cropped-image">
        <img [src]="croppedImage"/>
      </div>
      <div class="save-btn-box">
        <button class="w-btn orange-btn" (click)="saveImage()">Save picture</button>
      </div>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
